//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';
import { i18n } from '@/vueI18n';
import moment from 'moment';
// import GuideViewModal from '@/modules/reviews/components/reviews-view-modal.vue';

// import { GuidePermissions } from '@/modules/reviews/reviews-permissions';
// import { GuideModel } from '@/modules/reviews/reviews-model';
// import { FormSchema } from '@/shared/form/form-schema';
// const { fields } = GuideModel;

import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore'

import LoadingGuideCard from '@/modules/trip/components/partial-components/loading/loading-guide-card.vue';

export default {
  name: 'app-guide-card',

  props: {
    id: {
      type: String,
      required: true,
    } 
  },

  components: {
    [LoadingGuideCard.name]: LoadingGuideCard,
  },

  firestore() {
    return {
      guide: firebase.firestore().collection('user').doc(this.id),
    }
  },
  data() {
    return {
      dialog: false,
      dialogVisible: false,
      modalVisible: false,
      model: null,
      isMore: false,
      guide: undefined,
    }
  },
  computed: {
    ...mapGetters({
      // record: 'reviews/view/record',
      // loading: 'reviews/view/loading',
      // destroyLoading: 'reviews/destroy/loading',
      // changeStatusLoading: 'reviews/form/changeStatusLoading',

      isMobile: 'layout/isMobile',
      is_screen_xs: 'layout/is_screen_xs',
      is_screen_sm: 'layout/is_screen_sm',
      is_screen_md: 'layout/is_screen_md',
      is_screen_lg: 'layout/is_screen_lg',
      is_labtop: 'layout/is_labtop',
      currentUser: 'auth/currentUser',
      currentLanguageCode: 'layout/currentLanguageCode',
    }),
    // readMore() {
    //   return this.isMore
    // },
    guideAvatar() {
      if (this.guide) {
        if (this.guide.avatar ) {
          return this.guide.avatar.publicUrl 
        } else if (this.guide.avatars && this.guide.avatars.length) {
          return this.guide.avatars[0].publicUrl
        } 
      }
      return '/images/avatars/user-avatar.svg'
    },
  },
  methods: {
    ...mapActions({
      // doFind: 'reviews/view/doFind',
      // doDestroy: 'reviews/destroy/doDestroy',
      // doDisable: 'reviews/form/doDisable',
      // doEnable: 'reviews/form/doEnable',
    }),
    i18n(code, args) {
      return i18n(code, args);
    },
    presenterDate(val) {
      // return moment(GuideModel.presenter(row, fieldName)).locale(this.currentLanguageCode).format("D MMM, YYYY"); 
      return moment(val).locale(this.currentLanguageCode).format("D MMM, YYYY"); 
    },
    onOpenModal() {
      this.modalVisible = true;
      this.dialogVisible = true;
    },
    onModalClose() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.modalVisible = false;
      }, 200);
    },
  },
};
